import { createContext } from "react";

const AppContext = createContext({});

export default AppContext; // Export AppContext as the default export